/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { TNO_BUSINESS_PATROCINIO_PATH } from '../brandAssets';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      {/* Logo / identidad TNO Business */}
      <Box marginBottom={6}>
        <Box
          sx={{
            backgroundImage: 'url(/images/logos/logotnobusiness.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '28vh',
            mb: 2,
          }}
        />
      </Box>

      {/* Encabezado de autoridad */}
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        variant="overline"
        color="textSecondary"
        align="center"
        display="block"
        gutterBottom
      >
        TNO Business · Special Edition: Guest Experience
      </Typography>

      <Box
        component={Typography}
        fontWeight={700}
        variant="h3"
        gutterBottom
        align="center"
        color={theme.palette.primary.main}
      >
        Tu visión merece una plataforma a su altura
      </Box>

      <Typography
        variant="h6"
        component="p"
        color="textSecondary"
        align="center"
        sx={{ maxWidth: 800, mx: 'auto', mb: 4 }}
      >
        No solo es una entrevista; es la validación de tu liderazgo en el ecosistema corporativo más influyente de Venezuela.{' '}
        <strong>Conéctate con la audiencia que toma las decisiones.</strong>
      </Typography>

      <Box
        display="flex"
        justifyContent="center"
        flexWrap="wrap"
        gap={2}
      >
        <Button
          variant="contained"
          color="primary"
          size="large"
          href="#postulacion"
        >
          Postula tu historia
        </Button>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          href="#postulacion"
        >
          Solicita una entrevista
        </Button>
        <Button
          component={RouterLink}
          to={TNO_BUSINESS_PATROCINIO_PATH}
          variant="outlined"
          color="primary"
          size="large"
        >
          Patrocinar TNO Business
        </Button>
      </Box>
    </Box>
  );
};

export default Hero;

